// @ts-nocheck
import { observer } from "mobx-react-lite";
import React, { useState, useRef } from "react";
// import { uploadToCloudinary } from "../helpers";
import ImageEditor from "./ImageEditor";

// var img = loadImage('../yourimage.png', callback);
function toDataURL(url, callback) {
  var xhr = new XMLHttpRequest();
  xhr.onload = function () {
    var reader = new FileReader();
    reader.onloadend = function () {
      callback(reader.result);
    };
    reader.readAsDataURL(xhr.response);
  };
  xhr.open("GET", url);
  xhr.responseType = "blob";
  xhr.send();
}

export const ImageUploadHandler: React.FC<{
  image: any;
  render: any;
  onChange: (image: any) => Promise<string>;
  loading: boolean;
  hasError: boolean;
}> = observer(
  ({ image: defaultImage = null, render, onChange, loading, hasError }) => {
    const [image, setImage] = useState(defaultImage);
    const [showEditor, setEditor] = useState(false);
    const [files, setFiles] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const imageEditor = useRef<any>();

    React.useEffect(() => {
      if (defaultImage) {
        toDataURL(defaultImage, function (dataUrl) {
          setImage(dataUrl);
        });
      }
    }, [defaultImage]);

    const handleOpenModal = () => {
      setEditor(true);
    };

    const handleCloseModal = () => {
      setEditor(false);
    };

    const onDrop = (files) => {
      setFiles(files);
      setEditor(true);
    };

    const handleSave = () => {
      setLoading(true);
      if (imageEditor.current) {
        const canvasScaled = imageEditor.current.getImage();
        canvasScaled.toBlob((blob) => {
          onChange(blob)
            .then((result) => {
              setLoading(false);
              if (result) {
                setImage(result);
              } else {
                setImage(image);
              }
              setEditor(false);
            })
            .catch((error) => {
              setLoading(false);
              console.error(error);
              toDataURL(defaultImage, function (dataUrl) {
                setImage(dataUrl);
              });
              setEditor(true);
            });
        });
      }
    };

    const onDelete = () => {
      setImage("");
    };

    return (
      <React.Fragment>
        {render(
          image,
          isLoading,
          onDrop,
          onDelete,
          setEditor,
          loading,
          hasError,
        )}
        <ImageEditor
          key="fixed"
          ref={imageEditor}
          onClose={handleCloseModal}
          isOpen={showEditor}
          isLoading={isLoading}
          image={files.length > 0 ? files[0] : image}
          onSave={handleSave}
        />
      </React.Fragment>
    );
  },
);
